$(document).ready(function () {

    $(".template-collection #expandbtn").click(function () {
    if ($(".template-collection #portfolio").hasClass("readmore")) {
      $(".template-collection #expandbtn").html("Read More");
      $(".template-collection #portfolio").removeClass("readmore");
    } else {
      $(".template-collection #expandbtn").html("Read Less");
      $(".template-collection #portfolio").addClass("readmore");
    }
  });
  
   $("#read-btn").click(function () {
    if ($(".aftercontent.listcontent").hasClass("readmore")) {
      $("#read-btn").html("Read More");
      $(".aftercontent.listcontent").removeClass("readmore");
    } else {
      $("#read-btn").html("Read Less");
      $(".aftercontent.listcontent").addClass("readmore");
    }
  });
});




const dropupFuntion = () => {
        $(window).width() > 768 &&
            $(".site-navigation .site-nav__dropdown .has-submenu:not(:nth-child(-n+31))").each(function (t) {
                let n = $(window).scrollTop() + $(window).height(),
                    i = $(this).offset().top + $(this).outerHeight(),
                    e = $(this).find(".submenu-of-main");
                n - i < $(e).outerHeight() && $(e).addClass("dropup");
            });
    },
    displayTotalPrice = (t = null) => {
        setTimeout(function () {
            if ($(document).find(".product__price").length) {
                var t = $(document).find(".my_product__pricedata").html(), n = (t = t.trim()).charAt(0);
                t = (t = t.substring(1)).replace(/\,/g, "");
                var i = $(document).find(".js-qty__num").val(),
                    e = t * i;
                (e = n + parseFloat(e).toFixed(2)), $(document).find(".variant-total").html(e);
            }
        }, 500);
    };
$(document).ready(function () {
    dropupFuntion(),
        $(document).on("click", ".variant-input, .js-qty__adjust--plus, .js-qty__adjust--minus", function (t) {
            var n = $(this);
            displayTotalPrice(n);
        }),
        setTimeout(function () {
            displayTotalPrice();
        }, 500);
}),
    $(window).scroll(function () {
        var t = $(".main-header");
        $(window).scrollTop() >= 160 ? t.addClass("fixed") : t.removeClass("fixed");
    }),
    $(window).on("resize scroll", function () {
        dropupFuntion();
    });
var modal = document.getElementById("shippingModal"),
    btn = document.getElementById("shippingBtn"),
    span = document.getElementsByClassName("close")[0];
(btn.onclick = function () {
    modal.style.display = "block";
}),
    (span.onclick = function () {
        modal.style.display = "none";
    }),
    (window.onclick = function (t) {
        t.target == modal && (modal.style.display = "none");
    }),
    $(".header-layout.header-layout--center + .text-right").insertBefore(".header-item.header-item--icons .site-nav");

  $(document).ready(function() {
        $('#readMorecart').click(function() {
            $('.cart-description').toggleClass('expanded');
            if ($('.cart-description').hasClass('expanded')) {
                $(this).text('Read Less');
            } else {
                $(this).text('Read More');
            }
        });
    });



  $(document).ready(function () {
    $("#expandbtn , .homepagecustomsection #expandBtn").click(function () {
      console.log('123');
      if ($("#portfolio , .homepagecustomsection #portfolio").hasClass("readmore")) {
        $("#expandbtn , .homepagecustomsection #expandBtn").html("Read More");
        $("#portfolio , .homepagecustomsection #portfolio").removeClass("readmore");
      } else {
        $("#expandbtn , .homepagecustomsection #expandBtn").html("Read Less");
        $("#portfolio , .homepagecustomsection #portfolio").addClass("readmore");
      }
    });

     $(".pcd-gallery-slider a.btn-custom #expandbtn").click(function () {
             console.log('test');
     });
    
  });





jQuery(".aftercontent").insertAfter(".plp-collection");

document.querySelectorAll('.site-footer .infobox-title').forEach(title => {
   title.addEventListener('click', () => {
      title.parentElement.classList.toggle('active');
   });
});


